<template>{{@value}}</template>
